import React from "react";
import { Typography } from "antd";
import AdScriptComponent from "../AdScriptComponent/AdScriptComponent";
import "./PresentationAdComponent.less";

interface PresentationAdComponentProps {
  adContent: string;
}

const PresentationAdComponent: React.FC<PresentationAdComponentProps> = ({ adContent }) => {
  if (!adContent) {
    return null;
  }

  return (
    <div className="main-content-wrapper">
      <div className="main-container-image">
        <div className="slideItemPostImg slideItemPostImg-ad">
          <AdScriptComponent content={adContent} />
        </div>
      </div>
      <div className="slideItemFooter" style={{ paddingTop: "8px", paddingBottom: "16px" }}>
        <div style={{ marginBottom: "4px" }}>
          <Typography.Text className="slideItemLikeLabel">Sponsored content</Typography.Text>
        </div>
        <div>
          <Typography.Text className="slideItemLikeLabel">
            <span>Twizz</span> Advertisement
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default PresentationAdComponent;
